import React from 'react';
import { Attribute, UserData, PersonUserData } from './constants/types';

// TODO: figure out how this context is being used. It's suspicious that the set function isn't
//  used
interface AttributesContextInterface {
  attributes: UserData;
  setAttributes: (attributes: UserData) => void;
}

export const AttributesContext = React.createContext<AttributesContextInterface>({
  attributes: { genres: [] },
  setAttributes: () => { /* setAttributes placeholder */ },
});

interface SearchPaneResultsContextInterface {
  sortedSearchResults: PersonUserData[];
  setSortedSearchResults: (attributes: PersonUserData[]) => void;
}

export const SearchPaneResultsContext = React.createContext<SearchPaneResultsContextInterface>({
  sortedSearchResults: [],
  setSortedSearchResults: () => { /* setAttributes placeholder */ },
});

interface SearchTextContextInterface {
  searchText: string;
  setSearchText: (searchText: string) => void;
  showSearchInput: boolean;
  setShowSearchInput: (showSearchText: boolean) => void;
}
export const SearchTextContext = React.createContext<SearchTextContextInterface>({
  searchText: '',
  setSearchText: () => { /* setSearchText placeholder */ },
  showSearchInput: false,
  setShowSearchInput: () => { /* setShowSearchText placeholder */ },
});

interface BulkAddUsersContextInterface {
  newMembers: Record<string, unknown>[];
  setNewMembers: (newMembers: Record<string, unknown>[]) => void;
}
export const BulkAddUsersContext = React.createContext<BulkAddUsersContextInterface>({
  newMembers: [{}],
  setNewMembers: () => { /* setNewMembers placeholder */ },
});

interface BulkAddUsersAttributesContextInterface {
  bulkAttributes: Attribute[];
  setBulkAttributes: (bulkAttributes: Attribute[]) => void;
}
export const BulkAddUsersAttributesContext = React.createContext<BulkAddUsersAttributesContextInterface>({
  bulkAttributes: [],
  setBulkAttributes: () => { /* setBulkAttributes placeholder */ },
});

// TODO: figure out how this context is being used. It's suspicious that the set function isn't

interface LoggedInUserContextInterface {
  loggedInUser: UserData;
  setLoggedInUser: (loggedInUser: UserData) => void;
}//  used
export const LoggedInUserContext = React.createContext<LoggedInUserContextInterface>({
  loggedInUser: { genres: [] },
  setLoggedInUser: () => { /* setLoggedInUser placeholder */ },
});

